import type Store from "@ember-data/store";
import Route from "@ember/routing/route";
import type RouterService from "@ember/routing/router-service";
import { service } from "@ember/service";
import type CompoundSurveyCompletedJournalEvent from "parog-web/models/compound-survey-completed-journal-event";

import type Patient from "parog-web/models/patient";
import type NavigationService from "parog-web/services/navigation";

export interface CompoundSurveyCompletedAndPatient {
  patient: Patient;
  surveyCompletedJe: CompoundSurveyCompletedJournalEvent;
}

export default class CompoundSurveysNewRoute extends Route {
  @service declare navigation: NavigationService;
  @service declare router: RouterService;
  @service declare store: Store;

  override async model() {
    const patient = this.modelFor(
      "medics-web.protected.patients.patient"
    ) as Patient;

    await this.store.query("compound-survey-completed-journal-event", {
      filter: { patient_id: patient.id }
    });

    return patient;
  }
}
